/* styles.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["$borderRadius", "$aspectRatio"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _11 = "._1h1t4656{aspect-ratio:var(--_143uhpt)}";
const _10 = "._njlp1rrk{contain:layout paint}";
const _9 = "._bfhkn82g{background-color:var(--ds-skeleton,#091e420f)}";
const _8 = "._v564rca0{transition:background-color .3s}";
const _7 = "._18m915vq{overflow-y:hidden}";
const _6 = "._1reo15vq{overflow-x:hidden}";
const _5 = "._2rko1o9o{border-radius:var(--_pvl2wt)}";
const _4 = "._19itzgxb{border:1px solid var(--ds-border,#091e4224)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _3 = "._rsuf1h6o{object-position:center}";
const _2 = "._5ral1dfr{object-fit:cover}";
const _ = "._v5641dkx{transition:opacity .4s}";
export const Img = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_v5641dkx _5ral1dfr _rsuf1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Img.displayName = 'Img';
}
export const Container = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  const {
      $borderRadius,
      $aspectRatio
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5, _6, _7, _8, _9, _10, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_pvl2wt": ix(__cmplp.$borderRadius),
        "--_143uhpt": ix(__cmplp.$aspectRatio)
      }),
      ref: __cmplr,
      className: ax(["_19itzgxb _2rko1o9o _1reo15vq _18m915vq _v564rca0 _bfhkn82g _njlp1rrk _1h1t4656", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}